export enum ProcoreToolMode {
    Default = "default",
    Measure = "measure",
    Section = "section",
    Markup = "markup",
    Create = "create",
}

export type State = {
    /**
     * Ideally we could just infer the mode from the picker,
     * but when we just enter the mode - no picker is set yet,
     * so we need to store the mode explicitly.
     */
    activeToolMode: ProcoreToolMode;
};
